import React, { useState, useEffect } from 'react';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AmenitiesComponent } from '@/components/reusable/AmenitiesComponent/AmenitiesComponent';
import { SpecsSection } from '@/components/reusable/SpecsComponent/SpecsComponent';
import { GMapsComponent } from '@/components/reusable/GMapsComponent/GMapsComponent';
import { ReservationForm } from '@/components/general/Forms/ReservationForm';
import { Link } from 'react-router-dom';
import ShortReservationDetail from '@/components/general/Forms/ShortReservationDetail/ShortReservationDetail';
import CommmentsComponent from '@/components/reusable/CommentsComponent/CommentsComponent';
import Label from '@/components/form/Label/Label';
import ReactPixel from 'react-facebook-pixel';
import Modal from 'react-modal';
import NewSpaceCardRedesignDetailVersion from '@/components/reusable/NewSpaceCardRedesignDetailVersion/NewSpaceCardRedesignDetailVersion';
import HelmetComponent from '@/components/general/Helmet/HelmetComponent';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import 'react-comments-section/dist/index.css';
import './ProductDetails.scss';

const translations = {
  'Sala de Juntas': 'Meeting Room',
  Terrazas: 'Terrace',
  Coworking: 'Day Pass',
};

const HeadComponent = (props) => {
  const { spaceInfo, extraClass, lenguage, isFullScreenMap, setIsFullScreenMap } = props;
  const containerClass = 'justify-between ' + extraClass;
  const translatedType = translations[spaceInfo?.subtype_title] || spaceInfo?.subtype_title;
  const navigate = useNavigate();
  return (
    <FlexContainer className={containerClass}>
      <FlexContainer className={'flex-column align-self-left text-14 align-center margt6'}>
        <Label className={'margt10 text-22 m-text-18 toUpper'}>
          <strong>
            {lenguage === 'ES'
              ? spaceInfo?.subtype_title + ': ' + spaceInfo?.relationship_title
              : translatedType + ': ' + spaceInfo?.relationship_title}
          </strong>
        </Label>
        <Label className={'text-16 m-text-14'}>{spaceInfo?.space_address}</Label>
        <FlexContainer className={'gap-8 text-12 align-center margt6'}>
          <Label className={'text-16 m-text-14'}>
            <i className={'fa fa-star'} /> <strong> 5.0 </strong>
          </Label>
        </FlexContainer>
      </FlexContainer>
      <FlexContainer className={'gap-8 text-12 align-center margt10 align-items-end'}>
        {!isFullScreenMap && (
          <button
            type="button"
            className={'bgWhite border-rad4px padlr20 padtb6 fontGray500 text-16'}
            onClick={() => navigate(-1)}
          >
            {lenguage === 'EN' ? 'Back' : 'Atrás'}
          </button>
        )}
        {isFullScreenMap && (
          <button
            type="button"
            className={'bgWhite border-rad4px padlr20 padtb6 fontGray500 text-16'}
            onClick={() => setIsFullScreenMap(false)}
          >
            {lenguage === 'EN' ? 'Close Map' : 'Cerrar Mapa'}
          </button>
        )}
      </FlexContainer>
    </FlexContainer>
  );
};

const SpaceDetailInfo = (props) => {
  const { spaceData, spaceComment, isFullScreenMap, setIsFullScreenMap } = props;
  const lenguage = useSelector((state) => state.lenguage?.lang);
  const goToSpaceDetails = () => {
    ReactPixel.trackCustom('clickReservationButton', { clave: spaceData });
  };
  const wifi = true;
  const coffee = spaceData?.coffe_water === '1' ? true : false;
  const parking = spaceData?.parking === '1' ? true : false;
  const staff = spaceData?.staff === '1' ? true : false;
  const cleaning_service = spaceData?.cleaning_service === '1' ? true : false;
  const printing_service = spaceData?.printing_service === '1' ? true : false;
  const common_areas = spaceData?.common_areas === '1' ? true : false;
  const convention_hall = spaceData?.convention_hall === '1' ? true : false;
  const snacks = spaceData?.snacks === '1' ? true : false;
  const phone_service = spaceData?.phone_service === '1' ? true : false;

  if (spaceData) {
    return (
      <FlexContainer
        className={'flex-column bgWhite productPreList padt40 padb40 padlr130 m-padlr20'}
      >
        <HeadComponent
          spaceInfo={spaceData}
          lenguage={lenguage}
          extraClass={'padt50 m-padt20'}
          isFullScreenMap={isFullScreenMap}
          setIsFullScreenMap={setIsFullScreenMap}
        />
        <FlexContainer className={'m-flex-column width100 margt20 gap-20'}>
          {isFullScreenMap && (
            <GMapsComponent
              spaceData={spaceData}
              customHeight={'400px'}
              setIsFullScreenMap={setIsFullScreenMap}
            />
          )}
          {!isFullScreenMap && (
            <>
              <FlexContainer className={'flex-column format180 m-format100 margt10 m-gap-20'}>
                <NewSpaceCardRedesignDetailVersion
                  key={1}
                  spaceInfo={spaceData}
                  handleDetailButton={goToSpaceDetails}
                />
                <AmenitiesComponent
                  wifi={wifi}
                  coffee={coffee}
                  parking={parking}
                  staff={staff}
                  cleaning_service={cleaning_service}
                  printing_service={printing_service}
                  common_areas={common_areas}
                  convention_hall={convention_hall}
                  snacks={snacks}
                  phone_service={phone_service}
                  lenguage={lenguage}
                />
                <CommmentsComponent
                  spaceComment={spaceComment}
                  lenguage={lenguage}
                  extraClass={'d-hide'}
                />
                <SpecsSection spaceData={spaceData} lenguage={lenguage} />
              </FlexContainer>
              <FlexContainer className={'flex-column width100 margt10 gap-20'}>
                <CommmentsComponent
                  spaceComment={spaceComment}
                  lenguage={lenguage}
                  extraClass={'m-hide t-hide'}
                />
                <GMapsComponent
                  spaceData={spaceData}
                  lenguage={lenguage}
                  setIsFullScreenMap={setIsFullScreenMap}
                />
              </FlexContainer>
            </>
          )}
        </FlexContainer>
      </FlexContainer>
    );
  } else {
    return <></>;
  }
};

const DetailSpecsSection = (props) => {
  const { lenguage, spaceData } = props;
  return (
    <FlexContainer className={'flex-column format180 m-format100 margt10 gap-10'}>
      <Label className={'text-20 width100 margt10 text-justify'}>
        <strong>{lenguage === 'EN' ? 'Features' : 'Características'}</strong>
      </Label>
      <Label type="text-14" className={'width100 text-justify'}>
        <div
          dangerouslySetInnerHTML={{
            __html: lenguage === 'EN' ? spaceData?.space_details_en : spaceData?.space_details,
          }}
        />
      </Label>
    </FlexContainer>
  );
};

const FacilitiesInclude = (props) => {
  const { spaceDetail, lenguage } = props;
  return (
    <FlexContainer className={'bgBasicPopnestTwo m-flex-column padt20 padlr130 m-padlr20 gap-20'}>
      <FlexContainer className={'flex-column format180 m-format100 margt10 justify-between'}>
        <FlexContainer className={'flex-column'}>
          <Label className={'text-20 width100 margt10 text-justify'}>
            <strong>
              {lenguage === 'EN' ? 'Our Facilities Include' : 'Nuestras Instalaciones Incluyen'}
            </strong>
          </Label>
          <Label type="text-14" className={'width100 text-justify'}>
            <div
              dangerouslySetInnerHTML={{
                __html:
                  lenguage === 'EN'
                    ? spaceDetail?.space_details_general_en
                    : spaceDetail?.space_details_general,
              }}
            />
          </Label>
        </FlexContainer>
        <Link to={lenguage === 'EN' ? '/condiciones-privacidad' : '/condiciones-privacidad'}>
          {' '}
          <Label className={'text-20 width100 margt10 padb40 text-justify'}>
            <strong>
              {lenguage === 'EN' ? 'Cancellation Policies' : 'Políticas de Cancelación'}
            </strong>
          </Label>
        </Link>
      </FlexContainer>
      <FlexContainer className={'flex-column format100 margt10 gap-10 fontWhite'}>
        <img src={'/Logotipo_Popnest.png'} alt={''} className={'width100'} />
      </FlexContainer>
    </FlexContainer>
  );
};

const NewProductDetails = (props) => {
  const { spaceDetail, spaceComments } = props;
  const [modalIsOpen, setIsOpen] = useState(false);
  const [mapIsOpen, setMapIsOpen] = useState(false);
  const [isFullScreenMap, setIsFullScreenMap] = useState(false);
  const lenguage = useSelector((state) => state.lenguage?.lang);
  const navigate = useNavigate();

  let subtitle;

  const openModal = () => {
    setIsOpen(true);
  };

  const afterOpenModal = () => {
    subtitle.style.color = '#f00';
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const customStyles = {
    overlay: {
      position: 'fixed',
      zIndex: 4,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(255, 255, 255, 0.75)',
    },
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      maxHeight: '95vh',
      overflowy: 'auto',
    },
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <FlexContainer className={'flex-column m-margt20'}>
      {!mapIsOpen && (
        <>
          <SpaceDetailInfo
            spaceData={spaceDetail}
            spaceComment={spaceComments}
            lenguage={lenguage}
            isFullScreenMap={isFullScreenMap}
            setIsFullScreenMap={setIsFullScreenMap}
            closeButton={''}
          />
          <FlexContainer className={'m-flex-column padt20 bgGray050 padlr130 m-padlr20 gap-20'}>
            <DetailSpecsSection spaceData={spaceDetail} lenguage={lenguage} />
            <ShortReservationDetail
              className={
                'bgWhite format90 m-formatAuto flex-column margtb20 border-rad8px padlr20 padt20 m-padlr10'
              }
              spaceDetail={spaceDetail}
              onClick={openModal}
            />
          </FlexContainer>
          <FacilitiesInclude spaceDetail={spaceDetail} lenguage={lenguage} />
          <Modal
            isOpen={modalIsOpen}
            onAfterOpen={afterOpenModal}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="Revervation Form Modal"
          >
            <h2 ref={(_subtitle) => (subtitle = _subtitle)}></h2>
            <button
              className={'bgWhite border-rad8px borderGray5 fright grayShadow16 m-margt60'}
              onClick={closeModal}
            >
              x
            </button>
            <ReservationForm
              className={'bgWhite border-rad8px padlr20 m-padlr10 m-padt60'}
              spaceDetail={spaceDetail}
              backButton={closeModal}
            />
          </Modal>
        </>
      )}
      {mapIsOpen && <GMapsComponent spaceData={spaceDetail} lenguage={lenguage} />}
    </FlexContainer>
  );
};

export default NewProductDetails;
